var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.group === null)?_c('div',{staticClass:"loading"},[_c('i',{staticClass:"icon-spin1"})]):_c('div',{staticClass:"group"},[_c('About',{attrs:{"group":_vm.group}}),_c('Content',{attrs:{"group":_vm.group}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }